var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.68906 5V3.58906H6.31094V5H7.68906ZM7.68906 10.6109V6.41094H6.31094V10.6109H7.68906ZM2.04531 2.17813C3.42344 0.800001 5.075 0.110938 7 0.110938C8.925 0.110938 10.5656 0.800001 11.9219 2.17813C13.3 3.53438 13.9891 5.175 13.9891 7.1C13.9891 9.025 13.3 10.6766 11.9219 12.0547C10.5656 13.4109 8.925 14.0891 7 14.0891C5.075 14.0891 3.42344 13.4109 2.04531 12.0547C0.689063 10.6766 0.0109378 9.025 0.0109378 7.1C0.0109378 5.175 0.689063 3.53438 2.04531 2.17813Z",
    fill: "#458BEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.4f4436d3deec21999be15bdf5e2352c9.svg";
export { ForwardRef as ReactComponent };